import qs from 'qs';
import axios from './axios'

export default function generateService(endpoint) {

    function fetchSelectList(data) {
        return axios.get(`${endpoint}/select-list`, { params: data, paramsSerializer: params => qs.stringify(params, { encodeValuesOnly: true })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e;
        });
    }

    return {
        fetchSelectList
    }
}
